/**
 * runbookStore — in-memory holder for the current sandbox's runbooks.
 *
 * Deliberately NOT localStorage: runbooks belong to a specific sandbox and a
 * global key would cross-contaminate sandboxes (the known designStore bug).
 * Lifecycle: seeded from the gbox on load/import, upserted by v2:node:runbook
 * SSE events, folded into extensions.gotti_runbooks on save/fork/export, and
 * sent with every agent request. Unsaved runbooks are lost on reload —
 * acceptable: they are regenerable knowledge. No UI panel; no React coupling.
 */
import type { GboxRunbook } from '@gotti/sandbox-shared';

let runbooks = new Map<string, GboxRunbook>();

export function seedRunbooks(list: GboxRunbook[]): void {
  runbooks = new Map();
  for (const rb of list) {
    if (rb && typeof rb.id === 'string' && rb.id.length > 0) runbooks.set(rb.id, rb);
  }
}

export function upsertRunbook(rb: GboxRunbook): void {
  if (!rb || typeof rb.id !== 'string' || rb.id.length === 0) {
    console.warn('[runbookStore] ignoring malformed runbook payload', rb);
    return;
  }
  runbooks.set(rb.id, rb);
}

export function listRunbooks(): GboxRunbook[] {
  return [...runbooks.values()].sort((a, b) => {
    const ca = typeof a['createdAt'] === 'string' ? (a['createdAt'] as string) : '';
    const cb = typeof b['createdAt'] === 'string' ? (b['createdAt'] as string) : '';
    return ca === cb ? a.id.localeCompare(b.id) : ca.localeCompare(cb);
  });
}

export function clearRunbooks(): void {
  runbooks = new Map();
}
